var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2917 9.84087H16.6425C14.47 9.84087 12.7008 8.07171 12.7008 5.89921V3.25004C12.7008 2.74587 12.2883 2.33337 11.7842 2.33337H7.8975C5.07416 2.33337 2.79166 4.16671 2.79166 7.43921V15.5609C2.79166 18.8334 5.07416 20.6667 7.8975 20.6667H15.1025C17.9258 20.6667 20.2083 18.8334 20.2083 15.5609V10.7575C20.2083 10.2534 19.7958 9.84087 19.2917 9.84087Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9833 2.52579C14.6075 2.14995 13.9567 2.40662 13.9567 2.92912V6.12829C13.9567 7.46662 15.0933 8.57579 16.4775 8.57579C17.3483 8.58495 18.5583 8.58495 19.5942 8.58495C20.1167 8.58495 20.3917 7.97079 20.025 7.60412C18.705 6.27495 16.34 3.88245 14.9833 2.52579Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.b1a5ae57c1564e62073a60f01095b827.svg";
export { ForwardRef as ReactComponent };